<template>
    <!-- 隐私政策 -->
    <div>
        <div class="headerNav">
            <div class="headerNavYinShiLogo">
                <router-link to="/homePage"><img src="../assets/img/homePage/gongsi_logo.png" alt="" /></router-link>
            </div>
            <div class="headerNavPhoneEmail">
                <div class="navPhone">
                    <img src="../assets/img/homePage/dingbu_dianhua.png" alt="" />
                    <span>86 (021)-36511001</span>
                </div>
                <div>
                    <img src="../assets/img/homePage/dingbu_youxiang.png" class="dingbu_youxiang" alt="" />
                    <span>2629387311@qq.com</span>
                </div>
            </div>
        </div>
        <!-- 隐私政策  -->
        <div class="homePageLarge">
            <!--  -->
            <div class="crumbs">
                <span class="hoverColor"><router-link to="/homePage">返回首页</router-link></span>
                <span>隐私政策</span>
            </div>
            <div class="problemAll">
                <div class="Privacy-banner">
                    <h1 class="mag-20">上海胤石网络科技有限公司隐私政策</h1>
                    <p class="font-b1 mag-20">
                        本平台（“上海胤石网络科技有限公司”，该表述包括实际向您提供平台技术开发提供商及服务商），非常重视用户的隐私和个人信息保护。您在使用该平台与服务时，我们可能会收集和使用您的相关信息。我们希望通过本《隐私权政策》（“隐私政策”）向您说明我们在您使用我们的产品与/或服务时如何收集、使用、保存、共享和转让这些信息，以及我们为您提供的访问、更新、删除和保护这些信息的方式。
                    </p>
                    <div class="font-wold mag-20">
                        <span class="boeder-b"></span>我们如何收集个人信息性：
                    </div>
                    <p class="font-b1 mag-20">
                        "个人身份信息"是指以电子或者其他方式记录的能够单独或者结合其他信息以识别、联系或定位个人（比如：买家或卖家），或通过文字来辨认个人。
                    </p>
                    <p class="font-b1">
                        1、这包括但不仅限于个人买家或卖家的姓名、地址、电子邮件地址、电话号码、礼品消息内容、调查回复、付款详细信息、购物信息、Cookie、电子指纹（例如：浏览器，设备指纹）、IP地址、地理位置或互联网连接的设备产品标识符。
                    </p>
                    <p class="font-b1 mag-20">
                        2、包括从授权平台同步过来的数据，如：通过亚马逊获取产品或订单，包括买家的信息（PII）。
                    </p>
                    <div class="font-wold mag-20">
                        <span class="boeder-b"></span>您在使用我们的平台时主动提供的信息：
                    </div>
                    <p class="font-b1">
                        1、您在注册帐户时填写的信息，如：姓名、邮箱、手机号码。
                    </p>
                    <p class="font-b1 mag-20">2、您在使用时上传的信息。</p>
                    <div class="font-wold mag-20">
                        <span class="boeder-b"></span>我们在您使用服务时获取的信息：
                    </div>
                    <p class="font-b1">
                        1、我们自动收集的信息。当您使用我们的服务时，我们可能会自动收集相关信息并存储为服务日志信息。
                        日志信息：设备信息，IP地址，服务日志信息。
                    </p>
                    <p class="font-b1">2、验证您的身份。</p>
                    <p class="font-b1">3、解决争议和解决疑难问题。</p>
                    <p class="font-b1">
                        4、管理风险，或检测、预防和（或）修复欺诈或其他潜在的违禁或非法活动。
                    </p>
                    <p class="font-b1 mag-20">5、管理和保护我们的信息技术基础设施。</p>
                    <div class="font-wold mag-20">
                        <span class="boeder-b"></span>根据相关法律法规规定，以下情形中收集您的个人信息无需征得您的授权同意：
                    </div>
                    <p class="font-b1">1、与国家安全、国防安全有关的；</p>
                    <p class="font-b1">2、与公共安全、公共卫生、重大公共利益有关的；</p>
                    <p class="font-b1">3、与犯罪侦查、起诉、审判和判决执行等有关的；</p>
                    <p class="font-b1">
                        4、出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到您本人同意的；
                    </p>
                    <p class="font-b1">5、所收集的个人信息是您自行向社会公众公开的；</p>
                    <p class="font-b1">
                        6、从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；
                    </p>
                    <p class="font-b1">
                        7、用于维护所提供的产品或服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障；
                    </p>
                    <p class="font-b1 mag-20">8、法律法规规定的其他情形；</p>
                    <div class="font-wold mag-20">
                        <span class="boeder-b"></span>我们如何使用收集的信息：
                    </div>
                    <p class="font-b1 mag-20">
                        我们严格遵守法律法规的规定及与用户的约定，将收集的信息用于以下用途。若我们超出以下用途使用您的信息，我们将再次向您进行说明，并征得您的同意。
                    </p>
                    <div class="font-wolds mag-20">
                        数据访问及数据管理：
                    </div>
                    <div class="font-wolds">
                        1、数据访问
                    </div>
                    <p class="font-b1 mag-20">
                        您有义务按照本协议约定向我们提供履行服务所需的所有数据。本软件通过您的亚马逊帐户(“亚马逊帐户”)的授权以获取相关数据及报表，将明确并诚实地告知您需要访问的数据及其用途，
                        您必须确保我们被授予此目的所需的所有访问权限。根据亚马逊对个人身份信息保留政策要求，我们针对在您的买家订单发货之日起28天后自动删除您的买家个人身份信息，并且不做离线备份。
                    </p>
                    <p class="font-b1 mag-20">
                        您提供的用于分析的数据不得违反法律规定或侵犯第三方的权利。我们提供的服务不得用于非法或第三方侵权目的。如果发生违规行为，我们可能会暂停提供即时生效的服务或阻止您访问本软件。您赔偿我们因您违反上述约定而造成的任何损害，包括因实现上述债权而产生的费用，包括但不限于公证费、鉴定费、差旅费、办理费、律师费等。
                    </p>
                    <div class="font-wolds">
                        2、数据管理
                    </div>
                    <p class="font-b1 mag-20">
                        根据亚马逊的数据保护政策规定，我们必须为应用程序或服务创建、记录并遵守隐私以及数据处理策略，这些政策规定管理和保护信息资产时的适当行为和技术控制。我们必须保存能够访问PII的软件和实物资产(如计算机、移动设备)的库存，并定期进行更新。应维护数据处理活动的记录，如特定数据字段及其所有PII信息的收集、处理、存储、使用、共享和处置方式，以建立责任和遵守条例。我们必须建立并遵守客户同意的隐私政策和数据访问权，纠正、删除或停止共享/处理其信息(如适用)或数据隐私条例所要求的信息。
                    </p>
                    <div class="font-wolds">
                        3、要求删除
                    </div>
                    <p class="font-b1 mag-20">
                        在收到亚马逊通知并根据其要求删除亚马逊信息，必须由我们自行
                        立即（但必须在亚马逊的要求后不超过72小时之内）永久且安全地删除。我们还必须在亚马逊发出通知后的90天内永久安全地删除所有实时的（在线或网络可访问的）亚马逊信息实例。
                    </p>

                    <div class="font-wold mag-20">
                        <span class="boeder-b"></span>向您提供服务、管理软件、功能开发和平台维护：
                    </div>
                    <p class="font-b1 mag-20">
                        例如，当我们的系统发生故障时，我们会记录和分析系统故障时产生的信息，优化我们的服务。
                    </p>
                    <div class="font-wold mag-20">
                        <span class="boeder-b"></span>安全保障:
                    </div>
                    <p class="font-b1 mag-20">
                        例如，我们会将您的信息用于身份验证、安全防范、反诈骗监测、存档备份、客户的安全服务等用途。
                    </p>
                    <div class="font-wold mag-20">
                        <span class="boeder-b"></span>物流运输标签：
                    </div>
                    <p class="font-b1 mag-20">
                        我们会将您及卖方的个人信息用于商品运输标签
                    </p>
                    <div class="font-wold mag-20">
                        <span class="boeder-b"></span>其他用途：
                    </div>
                    <p class="font-b1 mag-20">
                        我们将收集的信息用于本隐私政策未载明的其他用途，或者将基于特定目的收集而来的信息用于其他目的时，会事先征求您的同意。
                    </p>
                    <div class="font-wold mag-20">
                        <span class="boeder-b"></span>我们如何共享、转让、公开披露您的个人信息
                    </div>
                    <div class="font-wolds mag-20">
                        共享，我们不会与本平台以外的任何公司、组织和个人共享您的个人信息，但以下情况除外：
                    </div>
                    <p class="font-b1">
                        1、事先获得您明确的同意或授权。
                    </p>
                    <p class="font-b1">
                        2、根据适用的法律法规、法律程序的要求、强制性的行政或司法要求所必须的情况下进行提供。
                    </p>
                    <p class="font-b1">
                        3、只有共享您的信息，才能实现我们的产品与/或服务的核心功能或提供您需要的服务。
                    </p>
                    <p class="font-b1 mag-20">
                        4、应您需求为您处理您与他人的纠纷或争议。
                    </p>
                    <div class="font-wolds mag-20">
                        转让，我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：
                    </div>
                    <p class="font-b1">
                        1、事先获得您明确的同意或授权；
                    </p>
                    <p class="font-b1 mag-20">
                        2、根据适用的法律法规、法律程序的要求、强制性的行政或司法要求所必须的情况下进行提供；
                    </p>
                    <div class="font-wolds mag-20">
                        公开披露，我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：
                    </div>
                    <p class="font-b1">
                        1、事先获得您明确的同意或授权；
                    </p>
                    <p class="font-b1 mag-20">
                        2、根据适用的法律法规、法律程序的要求、强制性的行政或司法要求所必须的情况下进行提供；
                    </p>
                    <div class="font-wold mag-20">
                        <span class="boeder-b"></span>我们如何保护和保存您的个人信息：
                    </div>
                    <p class="font-b1">
                        1、我们已采取符合业界标准、合理可行的安全防护措施保护您提供的个人信息安全，防止个人信息遭到未经授权访问、公开披露、使用、修改、损坏或丢失。
                    </p>
                    <p class="font-b1">
                        2、我们使用加密技术来确保数据的机密性。
                    </p>
                    <p class="font-b1">
                        3、我们会采取合理可行的措施，尽力避免收集无关的个人信息。我们只会在达成本隐私政策所述目的所需的期限内保留您的个人信息，除非需要延长保留期或受到法律的允许。
                    </p>
                    <p class="font-b1 mag-20">
                        4、我们使用可信的保护机制来防止对数据的恶意攻击
                    </p>
                    <div class="font-wold mag-20">
                        <span class="boeder-b"></span>本政策变更：
                    </div>
                    <p class="font-b1">1、我们可能适时修订本政策内容。</p>
                    <p class="font-b1">
                        2、如该政策变更会导致您在本政策项下权利的实质减损，我们将在变更生效前，通过在页面显著位置提示、向您发送电子邮件等方式通知您。
                    </p>
                    <p class="font-b1 mag-20">
                        3、在该种情况下，若您继续使用我们的服务，即表示同意受经修订的政策约束。
                    </p>
                    <div class="font-wold mag-20">
                        <span class="boeder-b"></span>我们如何收集个人信息性：
                    </div>
                    <p class="font-b1 mag-20">
                        如果您对本隐私政策或您个人信息的相关事宜有任何问题、意见或建议，您可通过发送邮件至客服邮箱<span
                            style="color: rgb(46, 109, 255)">（2629387311@qq.com）</span>与我们联系。
                    </p>
                </div>
            </div>
            <!-- <img loading="lazy" src="@/assets/img/homePage/gongsishouye_02.jpg" alt=""> -->
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
import { listFaq } from "@/api";
import { mapMutations } from "vuex";
import Footer from "@/components/Footer.vue";
export default {
    name: "YinshiOffcialwebsitePrivacyPolicy",
    data() {
        return {
        tableData: [],
        };
    },
    mounted() {},
    components: {
        Footer,
    },
    methods: {
        ...mapMutations(["GoTop"]),
        async selectTableData() {
        let res = await listFaq({ page: 1, pageSize: 999 });
        this.tableData = res.data;
        },
    },
    created() {
        this.$store.state.currentRouter = this.$route.path; //获取当前页面路由
        this.GoTop();
        this.selectTableData();
    },
    };
    </script>
<style lang="scss" scoped>
// 头部 logo和电话及邮箱
.headerNav {
    //整个div
    padding: 18px 270px;
    display: flex;
    justify-content: space-between;
    position: relative;
    z-index: 999;
    background: #fff;
    //logo
    .headerNavYinShiLogo {
        img {
        width: 167px;
        height: 45px;
        }
    }
    //电话及邮箱
    .headerNavPhoneEmail {
        display: flex;
        div {
        display: flex;
        align-items: center;
        margin-top: -5px;
        img {
            width: 15px;
            height: 15px;
            margin-top: 8px;
            padding: 0px 5px;
        }
        .dingbu_youxiang {
            width: 17px !important;
        }
        span {
            height: 13px;
            font-size: 16px;
            font-family: Microsoft YaHei, Microsoft YaHei-Regular;
            font-weight: 400;
            text-align: center;
            color: #444444;
        }
        }
        .navPhone {
        margin-right: 55px;
        }
    }
}
// 隐私政策
.homePageLarge {
    // 隐私政策面包屑
    .crumbs {
        background: #eeeeee;
        padding: 10.5px 270px;
        font-size: 16px;
        font-family: Microsoft YaHei, Microsoft YaHei-Regular;
        font-weight: 400;
        span:nth-child(1) {
        color: #666666;
        padding: 0px 11px;
        border-right: 1px solid #e1e1e1;
        cursor: pointer;
        margin-left: -11px;
        }
        a {
        transition: 0.2s;
        }
        .hoverColor a:hover {
        color: #7492d7 !important;
        }
        span:nth-child(2) {
        color: #666666;
        padding: 0px 11px;
        }
    }
    // 问题
    .problemAll {
        padding: 0px 270px;
        margin-top: 20px;
        .problem {
        .title {
            font-size: 16px;
            font-family: Microsoft YaHei, Microsoft YaHei-Bold;
            font-weight: 700;
            color: #444444;
        }
        .content {
            font-size: 16px;
            font-family: Microsoft YaHei, Microsoft YaHei-Regular;
            font-weight: 400;
            text-align: left;
            color: #666666;
            line-height: 32px;
            margin-top: 20px;
        }
        .contentBtn {
            width: 121px;
            height: 38px;
            background: #3b589a;
            border-radius: 5px;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #fff;
            margin-top: 30px;
        }
        padding: 50px 0px;
        border-bottom: 1px solid #d0d0d0;
        }
        .problem:last-child {
        padding: 50px 0px 70px 0px;
        border-bottom: 0px solid #d0d0d0;
        }
    }
}
.Privacy-banner h1 {
    font-family: PingFangSC-Regular, PingFang SC;
    text-align: center;
}
.mag-20 {
    margin-bottom: 20px;
}
.font-b1 {
    font-family: PingFangSC-Regular, PingFang SC;
    font-size: 14px;
    line-height: 32px;
    color: rgb(120, 121, 125);
}
.font-wold {
    font-size: 18px;
}
.boeder-b {
    border: 2px solid #3b589a;
    margin-right: 4px;
}
</style>
